@if (keywords(); as keywords) {
  <div class="keyword-list">

    <mat-toolbar>
      <span>Search Terms</span>
      @if (editable()) {
        <span class="spacer"></span>
        <button mat-raised-button
                aria-label="Generate Keywords"
                (click)="genKeywords()"
        >
          <mat-icon>draw</mat-icon>
          <span>Suggest search terms</span>
        </button>

        <button mat-raised-button
                aria-label="Create new Keyword"
                (click)="create()"
        >
          <mat-icon>add</mat-icon>
          <span>Add keyword</span>
        </button>
      }
    </mat-toolbar>

    <table mat-table [dataSource]="keywords" [class.editable]="editable()">

      <ng-container matColumnDef="and">
        <th mat-header-cell *matHeaderCellDef class="td-and"></th>
        <td mat-cell *matCellDef="let keyword; let i = index;" class="td-and">
          @if (i > 0) {
            <mat-icon
              matTooltip="AND"
            >add
            </mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="keyword">
        <th mat-header-cell *matHeaderCellDef> Keyword</th>
        <td mat-cell *matCellDef="let keyword"> {{ keyword.keyword }}</td>
      </ng-container>

      <ng-container matColumnDef="synonyms">
        <th mat-header-cell *matHeaderCellDef>
          Synonyms
        </th>
        <td mat-cell *matCellDef="let keyword">
          <mat-chip-set>
            @for (synonym of keyword.synonyms; track synonym) {
              <mat-chip>{{ synonym }}</mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openDialog(row)"></tr>
    </table>
    @if (generateLoading()) {
      <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
    }
    <app-info-card size="SMALL" [marginTop]="true">
        <span subtitle>
      Customize your search queries in the "Search Queries" step later. By default, keywords are combined with "AND", and each keyword's synonyms (incl. keyword) are grouped with "OR".
        </span>
    </app-info-card>
  </div>
}
